import styled from 'styled-components'
import { Link } from 'gatsby'

export const StyledAboutUsHeaderContainer = styled.div`
	display: grid;
	justify-items: flex-start;
	grid-row-gap: 32px;
	margin: 150px auto 40px auto;
	max-width: 1440px;
	box-sizing: border-box;
	padding: 12px 155px;
	@media (max-width: 1200px) {
		padding-left: 22px;
		padding-right: 22px;
	}
`

export const StyledAboutUsContainer = styled.div`
	display: grid;
	justify-items: flex-start;
	grid-row-gap: 32px;
	margin: 40px auto;
	max-width: 1440px;
	box-sizing: border-box;
	padding: 12px 155px;
	@media (max-width: 1200px) {
		padding-left: 22px;
		padding-right: 22px;
	}
`

export const StyledAboutUsSectionTitle = styled.h1`
	font-style: normal;
	font-weight: bold;
	font-size: 24px;
	line-height: 24px;
	color: #264445;
	@media (max-width: 1200px) {
		font-size: 20px;
	}
`

export const StyledAboutUsSectionDescriptionTxt = styled.p`
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	line-height: 28px;
	color: #979797;
	@media (max-width: 1200px) {
		font-size: 14px;
	}
`

export const StyledTeamImgWrapper = styled.img`
	width: 90%;
`

export const StyledButtonContainer = styled.div`
	display: inline-grid;
	grid-auto-flow: column;
	align-items: center;
	grid-column-gap: 45px;
	margin-top: 57px;
	position: relative;
	top: -20px;

	button {
		width: 180px;
		height: 56px;
		box-sizing: border-box;
	}

	@media (max-width: 768px) {
		margin-top: 66px;
		grid-column-gap: 20px;
	}
`

export const StyledBlogTitle = styled.h1`
	font-style: normal;
	font-weight: bold;
	font-size: 48px;
	line-height: 48px;
	color: #264445;
	display: grid;
	justify-items: center;
	@media (max-width: 1200px) {
		font-size: 40px;
		text-align: center;
	}
`

export const StyledPageInfoContainer = styled.div`
	display: grid;
	justify-items: center;
	grid-row-gap: 32px;
	margin: 171px auto;
	max-width: 1440px;
	box-sizing: border-box;
	padding: 12px 155px;
	@media (max-width: 1200px) {
		padding-left: 22px;
		padding-right: 22px;
	}
`

export const StyledBlogDescriptionTxt = styled.p`
	font-style: normal;
	font-weight: 500;
	font-size: 18px;
	text-align: center;
	line-height: 28px;
	color: #979797;
	max-width: 532px;
	@media (max-width: 1200px) {
		font-size: 14px;
		line-height: 1.5;
	}
`

export const StyledInnerInfo = styled.div`
	display: grid;
	grid-row-gap: 18px;
`

export const StyledBlogImageContainer = styled.div`
	position: relative;
	width: 100%;
	height: 268px;
	img {
		position: absolute;
		width: 100%;
		max-height: 268px;
	}

	@media (max-width: 600px) {
		height: 170px;

		img {
			max-height: 170px;
		}
	}

	@media (max-width: 350px) {
		height: 135px;

		img {
			max-height: 135px;
		}
	}
`

export const StyledBlogContainerUl = styled.ul`
	margin-top: 33px;
	display: grid;
	grid-template-columns: 1fr 1fr;
	grid-column-gap: 46px;
	grid-row-gap: 31px;
	@media (max-width: 960px) {
		grid-template-columns: 1fr;
	}
`

export const StyledBlogContainerLi = styled.li`
	padding: 38px;
	border: 1px solid #e5e5e5;
	box-sizing: border-box;
	border-radius: 4px;
	display: grid;
	grid-row-gap: 17px;
	@media (max-width: 1200px) {
		padding: 19px;
	}
`

export const StyledBlogContainerHeaderTitle = styled(Link)`
	font-style: normal;
	cursor: pointer;
	font-weight: bold;
	font-size: 24px;
	line-height: 24px;
	color: #37373a;
	text-decoration: none;
	${({ mrgbottom }) =>
		mrgbottom &&
		`
    margin-bottom: 32px;
  `};
	@media (max-width: 1200px) {
		font-size: 21px;
	}
	&:hover {
		text-decoration: underline;
	}
`

export const StyledBlogDate = styled.div`
	display: grid;
	grid-auto-flow: column;
	grid-column-gap: 12px;
	align-items: center;
	@media (max-width: 1200px) {
		grid-column-gap: 3px;
	}
`
export const StyledCircle = styled.div`
	width: 11px;
	height: 11px;
	border-radius: 50%;
	background-color: #c4c4c4;
`
export const StyledBlogPublishDateTxt = styled.p`
	font-style: normal;
	font-weight: normal;
	font-size: 18px;
	color: #979797;
	@media (max-width: 1200px) {
		font-size: 14px;
	}
	@media (max-width: 550px) {
		font-size: 12px;
	}
`

export const StyledBlogFooter = styled.div`
	display: flex;
	justify-content: space-between;
`

export const StyledLink = styled(Link)`
	color: inherit;
	display: grid;
	grid-auto-flow: column;
	column-gap: 9px;
	align-items: center;
	text-decoration: none;

	span {
		font-style: normal;
		font-weight: bold;
		font-size: 18px;
		text-transform: capitalize;
	}

	:hover {
		text-decoration: underline;
	}

	@media (max-width: 1200px) {
		justify-self: end;
		img {
			width: 15px;
		}

		span {
			font-size: 12px;
		}
	}
`

export const StyledReadModeTxt = styled.div`
	font-style: normal;
	font-weight: 500;
	font-size: 16px;
	color: #37373a;
	line-height: 28px;
	@media (max-width: 1200px) {
		font-size: 14px;
		line-height: 20px;
	}
`

export const StyledBackButton = styled.button`
	background: none;
	outline: none;
	cursor: pointer;
	border: none;
	display: grid;
	grid-auto-flow: column;
	column-gap: 12px;
	align-items: center;
	font-style: normal;
	font-weight: bold;
	font-size: 18px;
	line-height: 18px;
	color: #37373a;
	margin-bottom: 31px;
	@media (max-width: 1200px) {
		font-size: 14px;
		img {
			width: 20px;
		}
	}
`
export const StyledBackImage = styled.img`
	transform: rotate(180deg);
`

export const StyledBlogInnerContainer = styled.div`
	background: #ffffff;
	border: 1px solid #e5e5e5;
	box-sizing: border-box;
	border-radius: 4px;
	max-width: 1100px;
	padding: 2rem;
	margin: 5rem auto;
	@media (max-width: 550px) {
		padding: 4rem 20px;
		margin: 6rem 5px;
	}
`

export const StyledDetailInnerData = styled.div`
	@media (max-width: 1200px) {
		p {
			font-size: 12px;
			line-height: 12px;
		}
	}

	p {
		font-style: normal;
		font-weight: 500;
		font-size: 16.5px;
		line-height: 28px;
		color: #797a80;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	span,
	a {
		font-family: 'tbc-Regular', sans-serif;
		font-style: normal;
		line-height: 28px;
	}

	html,
	address,
	blockquote,
	body,
	dd,
	div,
	dl,
	dt,
	fieldset,
	form,
	frame,
	frameset,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	noframes,
	ol,
	p,
	ul,
	center,
	dir,
	hr,
	menu,
	pre {
		display: block;
		unicode-bidi: embed;
	}

	li {
		display: list-item;
	}

	head {
		display: none;
	}

	table {
		display: table;
	}

	tr {
		display: table-row;
	}

	thead {
		display: table-header-group;
	}

	tbody {
		display: table-row-group;
	}

	tfoot {
		display: table-footer-group;
	}

	col {
		display: table-column;
	}

	colgroup {
		display: table-column-group;
	}

	td,
	th {
		display: table-cell;
	}

	caption {
		display: table-caption;
	}

	th {
		font-weight: bolder;
		text-align: center;
	}

	caption {
		text-align: center;
	}

	body {
		margin: 8px;
	}

	h1 {
		font-size: 2em;
		margin: 0.67em 0;
	}

	h2 {
		font-size: 1.5em;
		margin: 0.75em 0;
	}

	h3 {
		font-size: 1.17em;
		margin: 0.83em 0;
	}

	h4,
	p,
	blockquote,
	ul,
	fieldset,
	form,
	ol,
	dl,
	dir,
	menu {
		margin: 1.12em 0;
	}

	h5 {
		font-size: 0.83em;
		margin: 1.5em 0;
	}

	h6 {
		font-size: 0.75em;
		margin: 1.67em 0;
	}

	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	b,
	strong {
		font-weight: bolder;
	}

	blockquote {
		margin-left: 40px;
		margin-right: 40px;
	}

	i,
	cite,
	em,
	var,
	address {
		font-style: italic;
	}

	pre,
	tt,
	code,
	kbd,
	samp {
		font-family: monospace;
	}

	pre {
		white-space: pre;
	}

	button,
	textarea,
	input,
	select {
		display: inline-block;
	}

	big {
		font-size: 1.17em;
	}

	small,
	sub,
	sup {
		font-size: 0.83em;
	}

	sub {
		vertical-align: sub;
	}

	sup {
		vertical-align: super;
	}

	table {
		border-spacing: 2px;
	}

	thead,
	tbody,
	tfoot {
		vertical-align: middle;
	}

	td,
	th,
	tr {
		vertical-align: inherit;
	}

	s,
	strike,
	del {
		text-decoration: line-through;
	}

	hr {
		border: 1px inset;
	}

	ol,
	ul,
	dir,
	menu,
	dd {
		margin-left: 40px;
	}

	ol {
		list-style-type: decimal;
	}

	ol ul,
	ul ol,
	ul ul,
	ol ol {
		margin-top: 0;
		margin-bottom: 0;
	}

	u,
	ins {
		text-decoration: underline;
	}

	br:before {
		content: '\\A';
		white-space: pre-line;
	}

	center {
		text-align: center;
	}

	:link,
	:visited {
		text-decoration: underline;
	}

	:focus {
		outline: thin dotted invert;
	}

	/* Begin bidirectionality settings (do not change) */

	bdo[DIR='ltr'] {
		direction: ltr;
		unicode-bidi: bidi-override;
	}

	bdo[DIR='rtl'] {
		direction: rtl;
		unicode-bidi: bidi-override;
	}

	*[DIR='ltr'] {
		direction: ltr;
		unicode-bidi: embed;
	}

	*[DIR='rtl'] {
		direction: rtl;
		unicode-bidi: embed;
	}

	@media print {
		h1 {
			page-break-before: always;
		}

		h1,
		h2,
		h3,
		h4,
		h5,
		h6 {
			page-break-after: avoid;
		}

		ul,
		ol,
		dl {
			page-break-before: avoid;
		}
	}
`
